import { Box, Typography, useTheme , Button, FormControl, FormLabel,RadioGroup,FormControlLabel,Radio,Tab,Tabs} from "@mui/material";
import { tokens } from "../../theme";
import NiceDate from "../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect,useMemo } from 'react';
import { getUser } from "../../slices/user";
import NiceCollection from "../../components/global/NiceCollection";
import NiceSignMode from "../../components/global/NiceSignMode";
import NiceSignBrightness from "../../components/global/NiceSignBrightness";
import NiceSignMessage from "../../components/global/NiceSignMessage";
import NiceSignImage from "../../components/global/NiceSignImage";
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { useParams,useSearchParams } from "react-router-dom"
import ThermostatIcon from '@mui/icons-material/Thermostat';
import PercentIcon from '@mui/icons-material/Percent';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import OnDeviceTrainingIcon from '@mui/icons-material/OnDeviceTraining';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import LightModeIcon from '@mui/icons-material/LightMode';
import { getSign , updateSign} from "../../slices/sign";
import SignService from "../../services/sign.service"
import { setMessage, clearMessage } from "../../slices/message"
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Header from "../../components/global/Header";
import { CirclePicker, TwitterPicker } from 'react-color';
import Popover from "@mui/material/Popover";
import Slider from '@mui/material/Slider';

import useInterval from "../../common/useInterval";
import MqttService from "../../services/mqtt.service"
import PropTypes from 'prop-types';

import SignMessages from "./SignMessages";
import SignImages from"./SignImages";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Sign = (props ) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const {id} = useParams()
  const dispatch = useDispatch();

  const sign = useSelector((state) => state.sign.data.list.find(sign => sign.id === id));  
  const adminUser = useSelector((state) => state.user.users.data.list.find(user => user.username == sign.administrator))

  const [commands, setCommands] = useState([]);
  
  const [tabValue, setTabValue] = React.useState(1);

  let refreshTimer = 20;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  useInterval(() => {
    
    commands.forEach((item, index, object) => {

      //check if the command is done and if it is refresh the sign
      MqttService.getCommand(item)
      .then((response) => {
        
        if (response.acknowlaged){
          dispatch(getSign({id}));
          //remove the command form the stack
          object.splice(index, 1);
        }
      
      })

    })

    //refreshTimer --;

    if (refreshTimer <= 0){
      refreshTimer = 20;
      dispatch(getSign({id}));
    }

  }, 1000);


  const sendSignBrightnessCommand = async ( id, brightness) => {

    try {
      const commandId = await SignService.setSignBrightness(id,brightness);
      return commandId;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      dispatch(setMessage(message));
  }
;}

const sendSignModeCommand = async ( id, mode) => {

  try {
    const commandId = await SignService.setSignMode(id,mode);
    return commandId;
  } catch (error) {
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();
    dispatch(setMessage(message));
}
;}

const addToCommandsList = (commandId) => {setCommands(current => [...current, commandId])}

function changeBrightness(value) {

  sendSignBrightnessCommand(sign.id,value)
  .then((response => {
    addToCommandsList(response.commandId)
  }))

}

  const sendSignColourCommand = async ( id, red,green,blue) => {

    try {
      const commandId = await SignService.setSignColour(id,red,green,blue);
      return commandId;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      dispatch(setMessage(message));
  }
;}

  function changeColor(color) {
    setColor(color.hex);

    //update the sign for real and add the commandId to be tracked 
    let red = color.rgb.r;
    let green = color.rgb.g;
    let blue = color.rgb.b;

    sendSignColourCommand(sign.id,red,green,blue)
    .then((response => {
      addToCommandsList(response.commandId)
    }))
  }

  const colours = [

    "#f4f5ef",
    "#f8c7a4",
    "#e784a8",
    "#eb9d45",
    "#bb9a3e",
    "#f6e455",
    "#c8dbdf",
    "#a146aa",
    "#d74d4c",
    "#a65d35",
    "#8fcb62",
    "#35884e",
    "#a0abb1",
    "#962f2c",
    "#682d2c",
    "#85dfeb",
    "#339ca3",
    "#1b4c5a",
    "#5e6a82",
    "#191023",
    "#72adee",
    "#435edb",
    "#474394",
    "#322d4d",
    "#000000",
    "#646464",
    "#ffffff",
    "#ff0000",
    "#00ff00",
    "#0000ff",

  ]


  const getTextColour = (backgroundColor) => {

    const vals = backgroundColor.split(',');
    const brightness = 1;

    var ir = Math.floor((255 - vals[0]) * brightness);
    var ig = Math.floor((255 - vals[1]) * brightness);
    var ib = Math.floor((255 - vals[2]) * brightness);
    return(`rgb(${ir}, ${ig}, ${ib})`);

  }

  function componentToHex(c) {
    let val = parseInt(c);
    let hex = val.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  
  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  const thisColour = sign ? sign.currentColour : "255,255,255";
  const rgb = thisColour.split(',');


  const [selectedColor, setColor] = useState(rgbToHex(rgb[0], rgb[1], rgb[2]));

  const signColour = "rgb(" + thisColour + ")"; 

  const textColour = getTextColour(thisColour);

  const [colourAnchorEl, setColourAnchorEl] = React.useState(null);

  const handleColourClick = (event) => {
    setColourAnchorEl(event.currentTarget);
  };

  const handleColourClose = () => {
    setColourAnchorEl(null);
  };

  const [modeAnchorEl, setModeAnchorEl] = React.useState(null);

  const handleModeClick = (event) => {
    setModeAnchorEl(event.currentTarget);
  };

  const handleModeClose = () => {
    setModeAnchorEl(null);
  };

  const [brightnessAnchorEl, setBrightnessAnchorEl] = React.useState(null);

  const handleBrightnessClick = (event) => {
    setBrightnessAnchorEl(event.currentTarget);
  };

  const handleBrightnessClose = () => {
    setBrightnessAnchorEl(null);
  };

  const openColour = Boolean(colourAnchorEl);
  const openBrightness = Boolean(brightnessAnchorEl);
  const openMode = Boolean(modeAnchorEl);

  const setMode = (mode) => {
    sendSignModeCommand(sign.id,mode)
    .then((response => {
      addToCommandsList(response.commandId)
    }))

  };


  useEffect(() => {

    if(!sign){

      //need to get the sign form the API
      dispatch(getSign({id}));
  
    }

    //if there are no users then we can go get it 
    if (!adminUser && sign){
      let username = sign?.administrator
      dispatch(getUser({username}));
    }


}, [sign]);

const [brightnessValue, setBrightnessValue] = React.useState(sign?.currentBrightness);

const brightnessValChange = (value) => {

  let val = (value / 255 * 100).toFixed(2)
  return val + '%';
}

const handleBrightnessChange = (event, newValue) => {
  //setValue(newValue);

  setBrightnessValue(newValue)
};

const handleBrightnessDone= (event, newValue) => {
  
  changeBrightness(newValue);

};

const [modeValue, setModeValue] = React.useState(sign?.currentMode);

  const handleModeChange = (event) => {
    setModeValue(event.target.value);
    setMode(event.target.value)
  };



  return (

    <>

      

    <Popover
        id="colour"
        open={openColour}
        anchorEl={colourAnchorEl}
        onClose={handleColourClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box
         p=".5rem 1rem 1rem 1rem"
        >
        <CirclePicker color={selectedColor} onChangeComplete={changeColor} colors = {colours} />
        </Box>
      </Popover>

      <Popover
        id="brigthness"
        open={openBrightness}
        anchorEl={brightnessAnchorEl}
        onClose={handleBrightnessClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box width="350px"  p="10px 35px 10px" display="flex" alignItems="baseline" flexDirection="column">
          <Typography>Brightness</Typography>
          <Slider
            aria-label="Brightness"
            value={brightnessValue}
            onChangeCommitted={handleBrightnessDone}
            onChange={handleBrightnessChange}
            valueLabelFormat={brightnessValChange}
            valueLabelDisplay="auto"
            step={10}
            marks
            min={5}
            max={255}
            sx={{
            mt: "10px"
          }}
          />
      </Box>
    </Popover>

    <Popover
        id="mode"
        open={openMode}
        anchorEl={modeAnchorEl}
        onClose={handleModeClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box width="350px"  p="10px 35px 10px" display="flex" alignItems="baseline" flexDirection="column">
          <FormControl>
            <FormLabel id="mode-group">Display Mode</FormLabel>

            <RadioGroup
              aria-labelledby="mode-group"
              name="mode-group"
              value={modeValue}
              onChange={handleModeChange}
            >
              <FormControlLabel value="0" control={<Radio />} label="Off" />
              <FormControlLabel value="1" control={<Radio />} label="Message" />
              <FormControlLabel value="2" control={<Radio />} label="Time" />
              <FormControlLabel value="3" control={<Radio />} label="Date" />
              <FormControlLabel value="4" control={<Radio />} label="Time & Date" />
              <FormControlLabel value="5" control={<Radio />} label="Tempture" />
              <FormControlLabel value="6" control={<Radio />} label="Light Level" />
              <FormControlLabel value="7" control={<Radio />} label="Humidity" />
              <FormControlLabel value="8" control={<Radio />} label="Image" />

            </RadioGroup>
          </FormControl>

      </Box>
    </Popover>

      


    <Box m="20px">

      <Box display="flex" alignItems="top">

        <Header title={sign?.name} subtitle={sign?.id} />
      </Box>

      
      <Box 
        display="flex"
        flexDirection="column"
        backgroundColor={colors.primary[300]} 
        padding="15px"
        sx={{ borderRadius:1}}
      >
        <Box
          display = "flex"
          flexDirection="row"
          justifyContent="space-between"
          mb="20px"
        >
        
        <Box display="flex" flexDirection="column">
        <Box display="flex" flexDirection="row">

          <Box display="flex" justifyContent="space-between" mr="10px">
            <ThermostatIcon/>
            <Typography display="inline">{sign?.currentTemp} C</Typography>
          </Box>
        
          <Box display="flex" justifyContent="space-between" mr="10px">
            <PercentIcon/>
            <Typography display="inline">{sign?.currentHumidity} %</Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" mr="10px">
            <LightbulbIcon/>
            <Typography display="inline">{sign?.currentLight}</Typography>
          </Box>

        </Box>

        <Box mt="10px"> 

          <Box display="flex" >
            <OnDeviceTrainingIcon/>
            <Typography 
              display="inline"
              onClick={handleModeClick}
              sx={{cursor: "pointer"}}
            >
              <NiceSignMode>{sign?.currentMode}</NiceSignMode>
            </Typography>

          </Box>

          <Box display="flex" flexDirection="row" mt="10px">
            <Box display="flex"  mr="10px">
              <ColorLensIcon/>
              <Box 
                backgroundColor={signColour} 
                p="0px 10px" 
                sx={{ borderRadius:2, cursor: "pointer"}} 
                color ={textColour}
                onClick={handleColourClick}
              >
                <Typography display="inline">{sign?.currentColour}</Typography>
              </Box>
            </Box>

            <Box display="flex"  mr="10px" >
              <LightModeIcon/>
              <Typography 
                display="inline"
                onClick={handleBrightnessClick}
                sx={{cursor: "pointer"}}
              >
                <NiceSignBrightness>{sign?.currentBrightness}</NiceSignBrightness>
              </Typography>
            </Box>
          
          </Box>
            <Box display="flex"  mt="10px">
                <EmailOutlinedIcon/>
                <Typography 
                  display="inline"
                >
                  {sign &&
                    <NiceSignMessage>{sign.currentMessage}</NiceSignMessage>
                  }
                </Typography>
              </Box>

              <Box display="flex"  mt="10px">
                <CameraAltOutlinedIcon/>
                <Typography 
                  display="inline"
                >
                  {sign &&
                    <NiceSignImage>{sign.currentImage}</NiceSignImage>
                  }
                </Typography>
              </Box>

          </Box>
          </Box>

          <Box display="flex" flexDirection="column" width="200px">
            <Typography variant="h4">
              {sign?.typeName}
            </Typography>
            <Typography>
              {sign?.rows} rows
            </Typography>
            <Typography>
              {sign?.columns} columns
            </Typography>
            {sign?.hasBuzzer 
            ? 
            <Typography>
              Has a Buzzer
            </Typography>
            :
              <Typography>
              No Buzzer
            </Typography>
            }         
            <Typography>
              With {sign?.outputs} outputs
            </Typography>
          </Box>

          <Box display="flex" width="120px">
            <AccountTreeIcon/>
            <Typography variant="h6" ml="10px">
              
                {sign &&
                  <NiceCollection>{sign?.collection}</NiceCollection>
                } 
              
            </Typography>
          </Box>


      </Box>
      

      <Typography>
        Sign first seen <NiceDate>{sign?.createdAt}</NiceDate> and last seen <NiceDate>{sign?.lastHeartBeat}</NiceDate>
      </Typography>
      <Typography>
        {sign?.description}
      </Typography>

        
      </Box>

      <Box  mt="20px" sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="Sign Tabs">
            <Tab label="Messages" {...a11yProps(0)} />
            <Tab label="Images" {...a11yProps(1)} />
            <Tab label="History" {...a11yProps(2)} />
            <Tab label="Commands" {...a11yProps(3)} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>

          {sign &&      
            <SignMessages sign = {sign} commandCallBack = {addToCommandsList}></SignMessages>
          }
          
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          
          {sign &&
            <SignImages sign = {sign} commandCallBack = {addToCommandsList}></SignImages>
          }
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          History
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
        <Box>

          {commands.map((command) => (
                <Typography key ={command}>{command}</Typography> 
              ))}
          </Box>
        </TabPanel>

      </Box>

    </Box>

    

    </>
  );
};

export default Sign;
